import { render, staticRenderFns } from "./PhotosModule.vue?vue&type=template&id=56bebf04&scoped=true"
import script from "./PhotosModule.vue?vue&type=script&lang=js"
export * from "./PhotosModule.vue?vue&type=script&lang=js"
import style0 from "./PhotosModule.vue?vue&type=style&index=0&id=56bebf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bebf04",
  null
  
)

export default component.exports